import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import type { CurrencyRate } from './currency-rate.model';
import { TEST_CURRENCY_RATES } from './currency-rates.fixture';
import type { CurrencyRatesSource } from './currency-rates-source';

@Injectable({
  providedIn: 'root',
})
export class TestCurrencyRatesSource implements CurrencyRatesSource {
  readonly id = 'test' as const;

  loadRates(): Observable<CurrencyRate[]> {
    return of(TEST_CURRENCY_RATES);
  }
}
